import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../Assets/Images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const handleNavigation = (path) => {
  //   console.log("📍 Navigating to:", path);

  //   // Close offcanvas if it's open
  //   const offcanvas = document.getElementById("offcanvasTop");
  //   if (offcanvas && offcanvas.classList.contains("show")) {
  //     const bsOffcanvas = window.bootstrap?.Offcanvas.getInstance(offcanvas);
  //     if (bsOffcanvas) {
  //       bsOffcanvas.hide();
  //     }
  //   }

  //   // Use React Router navigation
  //   navigate(path);
  // };

  // Test with a simple navigation first
  const testNavigation = (path) => {
    // console.log("📍 Test navigation clicked");

    // ✅ Close offcanvas if open
    const offcanvasEl = document.getElementById("offcanvasTop");
    if (offcanvasEl && offcanvasEl.classList.contains("show")) {
      const bsOffcanvas = window.bootstrap?.Offcanvas.getInstance(offcanvasEl);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }

    // ✅ Clean up Bootstrap leftovers
    setTimeout(() => {
      // Remove backdrop
      const backdrop = document.querySelector(".offcanvas-backdrop");
      if (backdrop) backdrop.remove();

      // Restore body scroll
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      document.body.classList.remove("offcanvas-backdrop");
      document.body.classList.remove("offcanvas-open");

      // ✅ Navigate
      navigate(path);
    }, 200);
  };

  return (
    <>
      <nav
        className={`navbar fixed-top py-2 py-lg-4 ${
          scrolled ? "bg-white shadow-sm" : "custom-navbar"
        } `}>
        <div className="container-fluid justify-content-between">
          <button
            className="navbar-brand text-dark fw-bold border-0 bg-transparent p-0"
            onClick={() => testNavigation("/")}>
            <img src={Logo} alt="Logo" className="logo" />
          </button>
          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasTop"
            aria-controls="offcanvasTop">
            <FontAwesomeIcon icon={faBars} className="navbar-toggler-icon" />
          </button>
        </div>
      </nav>

      <div
        className="offcanvas offcanvas-top custom-offcanvas"
        tabIndex="-1"
        id="offcanvasTop"
        aria-labelledby="offcanvasTopLabel">
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close btn-close-white shadow-none"
            data-bs-dismiss="offcanvas"
            aria-label="Close"></button>
        </div>
        <div className="offcanvas-body custom-menu overflow-hidden">
          <ul className="list-unstyled w-100">
            <li>
              <button
                className="nav-link custom-link border-0 bg-transparent w-100 text-start"
                onClick={() => testNavigation("/")}>
                Home
              </button>
            </li>
            <li>
              <button
                className="nav-link custom-link border-0 bg-transparent w-100 text-start"
                onClick={() => testNavigation("/about")}>
                About Us
              </button>
            </li>
            <li>
              <button
                className="nav-link custom-link border-0 bg-transparent w-100 text-start"
                onClick={() => testNavigation("/service")}>
                Services
              </button>
            </li>
            <li>
              <button
                className="nav-link custom-link border-0 bg-transparent w-100 text-start"
                onClick={() => testNavigation("/gallery")}>
                Gallery
              </button>
            </li>
            <li>
              <button
                className="nav-link custom-link border-0 bg-transparent w-100 text-start"
                onClick={() => testNavigation("/contact")}>
                Contacts
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;
